import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-search",
  "use": "icon-search-usage",
  "viewBox": "0 0 1165 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1165 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-search\"><path d=\"M1070.102 841.952L894.918 705.66a449.98 449.98 0 10-65.082 82.198q12.938-12.938 24.66-26.734l173.517 134.966a34.295 34.295 0 1042.09-54.124zm-557.618 8.792c-209.682 0-380.283-170.586-380.283-380.283S302.755 90.178 512.437 90.178 892.72 260.826 892.72 470.46 722.134 850.744 512.437 850.744z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol